module.exports = __webpack_public_path__ + "static/media/favButtonIcon.66c04f45.svg";